import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=04bc8079"
import script from "./Behavior.vue?vue&type=script&lang=js"
export * from "./Behavior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports